import SEO from "@/components/site/SEO";
import PricingTeaser from "@/components/sections/PricingTeaser";
import FAQ from "@/components/sections/FAQ";

export default function Pricing() {
  return (
    <div data-testid="page-pricing">
      <SEO title="Pricing" description="SECQRE pricing: Single, Family and Business packs. Buy once, stay private forever." path="/pricing" />
      <section className="pt-32 md:pt-40 pb-6">
        <div className="container-secqre text-center max-w-3xl mx-auto">
          <span className="overline">— Pricing</span>
          <h1 className="mt-4 font-heading font-black text-5xl sm:text-6xl lg:text-7xl tracking-tight" data-testid="pricing-page-title">
            Honest pricing.<br />One-time, like a sticker should be.
          </h1>
          <p className="mt-6 text-lg text-[#475569]">No subscriptions. No phone-number plans. Free US shipping over $25.</p>
        </div>
      </section>
      <PricingTeaser full />
      <FAQ />
    </div>
  );
}
